import { UpperCasePipe } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { UserMessagesComponent } from '@zero/shared/ui-web-components';
import { ButtonComponent } from '@zero/shared/ui-web-design-system';
import { MinimumQuantitySurcharge } from '@zero/trade/domain';
import { DonauCapitalHintComponent } from '../donau-capital-hint/donau-capital-hint.component';

@Component({
  selector: 'trade-confirm-button',
  templateUrl: './trade-confirm-button.component.html',
  imports: [UserMessagesComponent, TranslocoPipe, ButtonComponent, UpperCasePipe, DonauCapitalHintComponent],
})
export class TradeConfirmButtonComponent {
  @Input() public disabled = false;
  @Input() public minimumQuantitySurcharge?: MinimumQuantitySurcharge;

  @Output() public confirmLowTradingAndPlaceOrder = new EventEmitter<void>();
  @Output() public placeOrder = new EventEmitter<void>();
}
